import React from 'react';
import Layout from '@/layouts/main';
import { Mixpanel } from '@/utils';
import FAQView from '@/views/FAQ';

export default function FAQPage() {
  React.useEffect(() => Mixpanel.track(`View FAQ Page`), []);

  return (
    <Layout
      title="FAQ - Transforming your health through your gut"
      description="We aim to reduce over-dependence on pills by using good food to better the health
outcomes of people living with anxiety and depression."
      active="faq"
    >
      <FAQView />
    </Layout>
  );
}
